// extracted by css-extract-rspack-plugin
export default {"card-link":"card-link___sOAajXlW","card-link--hover-shadow":"card-link--hover-shadow___NkRICpN_"};